<template>
    <div id="tag">
        <DefaultPageComponent
        :loading="loading"
        :title="'Classificação de E-mails'"
        :haveBackButton="true"
        @onBack="$router.push('/email-classification')"
        >

        <!-- CONTENT -->
        <div class="py-3">
            <b-row class="py-2 mx-2">
                <div class="d-flex w-100">
                    <div class="form-group" style="width: 570px;">
                        <b-col>
                            <label for="">Título</label>
                            <input type="text" class="form-control form-control-sm" id="inputUserName" style="box-shadow: none; height: 56px;" v-model="emailClassification.title">
                        </b-col>
                    </div>
                    <div class="form-group flex-grow-1">
                        <b-col>
                            <label for="">Descrição</label>
                            <input type="text" class="form-control form-control-sm" id="inputUserName" style="box-shadow: none; height: 56px;" v-model="emailClassification.description">
                        </b-col>
                    </div>
                </div>
            </b-row>
        </div>

        <template #footer>
            <b-row>
                <b-col class="d-flex justify-content-end">
                    <CancelButton
                    @click="$router.push('/email-classification')"
                    >
                        Cancelar
                    </CancelButton>
                    <CustomButton
                    :loading="loading || loadingSubmit"
                    :disabled="emailClassification.title === ''"
                    @click="saveEmailClassification"
                    > 
                        Salvar
                    </CustomButton>
                </b-col>
            </b-row>
        </template>

        </DefaultPageComponent>

    </div>  
</template>

<script>
import DefaultPageComponent from '@/components/DefaultPageComponent.vue';
import CustomButton from '@/components/CustomButton.vue';
import CancelButton from '@/components/CancelButton.vue';
export default {
    name: 'TagEditView',
    components:{
        DefaultPageComponent,
        CustomButton,
        CancelButton,
    },
    data () {
        return {
            loadingSubmit: false,
            loading: false,
            emailClassification: {
                title: '',
                description: '',
            },
        }
    },
    mounted () {
        this.getEmailClassification();
    },
    methods: {
        getEmailClassification() {
            this.loading=true;
            this.$axios.get(`email-classification/${this.$router.currentRoute.params.id}`).then((response) => {
                this.emailClassification = response.data.data;
            }).catch(() => {
                this.$swal({
                    title: 'Erro',
                    text: 'Não foi possível consultar a classificação.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#C44C30',
                    allowOutsideClick: false,
                });
            })
            .finally(()=>{
                this.loading=false;  
            })
        },
        async saveEmailClassification () {
            if (this.emailClassification.title === ''){
                this.$swal({
                    title: 'Atenção',
                    text: 'Existe(m) campo(s) obrigatório(s) ainda não preenchido(s)!',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#C44C30',
                    allowOutsideClick: false,
                });
                return;
            }

            this.loading = true;

            let emailClassification = this.emailClassification;

            this.$axios.put(`email-classification/${this.$router.currentRoute.params.id}`, emailClassification).then(() => {
                this.$swal({
                    title: 'Registro atualizado',
                    text: 'Registro atualizado com sucesso.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#EB694A',
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                        confirmButton: 'custom-confirm-button-class',
                    }
                });
                this.$router.push('/email-classification');
            }).catch(() => {
                this.$swal({
                    title: 'Erro',
                    text: 'Não foi possível atualizar a classificação.',
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#C44C30',
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'custom-confirm-button-class',
                    }
                });
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style>
    #customer {
        height: calc(100vh - 125px);
    }

    .custom-control-input:checked ~ .custom-control-label::before {
        color: #fff !important;
        border-color: #EB694A !important;
        background-color: #EB694A !important;
        box-shadow: none !important;
    }
</style>
